module.exports = __webpack_public_path__ + "img/pipe-2.a28352a8.jpg";